<div mat-dialog-content>
    Are you sure? this change will impact users of following levels..
  <ul>
    <li *ngFor="let item of data.levels">{{item.level}}</li>
  </ul>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>No Thanks</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</div>